import { EventEmitter, Injectable } from '@angular/core';

import { MenuItem } from '../_classes/menu-item';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  mostrarMenuEmitter = new EventEmitter<boolean>();

  itensDeMenu: MenuItem[] = [
    /*desabilitado a pedido do cliente
  chamado 10920 Citsmart
  new MenuItem({
      nome: 'AFASTAMENTOS-> Dias a compensar',
      link: '/sgrh-credito',
      hint: 'Lista os dias que tenho a compensar, inclusive os que já usei',
    }),*/
    new MenuItem({
      nome: 'AFASTAMENTOS-> Frequência',
      link: '/frequencia',
      hint: 'Lista as entradas e saídas do TRT',
    }),
    new MenuItem({
      nome: 'AFASTAMENTOS-> Geral',
      link: '/afastamento',
      hint: 'Listagem de todos os afastamentos',
    }),
    new MenuItem({
      nome: 'AFASTAMENTOS-> Ausências e faltas',
      link: '/ausencia',
      hint: 'Listagem dos afastamentos do tipo ausências ou faltas',
    }),
    new MenuItem({ nome: 'AFASTAMENTOS-> Férias', link: '/ferias', hint: '' }),
    new MenuItem({
      nome: 'AFASTAMENTOS-> Licenças',
      link: '/licenca',
      hint: 'Listagem dos afastamentos do tipo licença',
    }),
    new MenuItem({
      nome: 'AFASTAMENTOS-> Suspensão',
      link: '/suspensao',
      hint: 'Listagem dos afastamentos do tipo suspensão',
    }),
    new MenuItem({
      nome: 'AFASTAMENTOS-> Outros',
      link: '/afastamento-outros',
      hint: 'Listagem de qualquer tipo de afastamento que não se enquadre nos outros',
    }),
    new MenuItem({
      nome: 'FINANCEIRO-> Benefícios',
      link: '/beneficio',
      hint: 'Informações sobre benefícios cadastrados',
    }),
    new MenuItem({
      nome: 'FINANCEIRO-> Contas Bancárias',
      link: '/conta-pessoal',
      hint: 'Informações da conta bancária onde é depositado qualquer crédito pelo TRT',
    }),
    {
      nome: 'FINANCEIRO-> Comprovante Rendimentos',
      link: '/comprovante-rendimento',
      hint: 'Listagem dos comprovantes anuais de rendimentos',
    },
    {
      nome: 'FINANCEIRO-> Descontos Dirf',
      link: '/desconto-dirf',
      hint: 'Listagem recolhimentos feitos na DIRF anual',
    },
    new MenuItem({
      nome: 'FINANCEIRO-> Consignado',
      link: '/consignado',
      hint: 'Informações sobre consignados',
    }),
    new MenuItem({
      nome: 'FINANCEIRO-> Holerites',
      link: '/holerite',
      hint: 'Listagem de holerites recebidos',
    }),
    new MenuItem({
      nome: 'FUNCIONAL-> Tempo de Serviço',
      link: '/tempo-servico',
      hint: 'Tempo de serviço averbado, incluindo o público do  TRT',
    }),
    new MenuItem({
      nome: 'FUNCIONAL-> Avaliações',
      link: '/avaliacao',
      hint: 'Resumo das avaliações recebidas',
    }) /*desabilitado a pedido do cliente
  chamado 10920 Citsmart
    new MenuItem({
      nome: 'FUNCIONAL-> Banco de Horas',
      link: '/banco-horas',
      hint: 'Relação de horas que tenho no Banco de Horas',
    }),*/,
    ,
    new MenuItem({
      nome: 'FUNCIONAL-> Dados funcionais',
      link: '/dados-funcionais',
      hint: 'Meus dados funcionais aqui no TRT',
    }),
    new MenuItem({
      nome: 'FUNCIONAL-> Elogios e Penalidades',
      link: '/elogio',
      hint: 'Informações sobre elogios e penalidades recebidas',
    }),
    new MenuItem({
      nome: 'FUNCIONAL-> Evolução na Carreira',
      link: '/evolucao-carreira',
      hint: 'Informações sobre evolução na carreira',
    }),
    new MenuItem({
      nome: 'FUNCIONAL-> Lotação',
      link: '/lotacao',
      hint: 'Informações de lotação',
    }),
    new MenuItem({
      nome: 'PESSOAL-> Curriculo',
      link: '/curriculo',
      hint: 'Informações de currículo e grupos de AQ',
    }),
    new MenuItem({
      nome: 'PESSOAL-> Dados pessoais',
      link: '/dados-pessoais',
      hint: 'Informações que constam no sistema de RH',
    }),
    new MenuItem({
      nome: 'PESSOAL-> Dependentes',
      link: '/dependente',
      hint: 'Lista de dependentes',
    }),
    new MenuItem({
      nome: 'PESSOAL-> Documentos pessoais',
      link: '/pessoa-documento',
      hint: 'Informações sobre documentos pessoais',
    }),
    new MenuItem({
      nome: 'SISTEMAS-> Me Encontre',
      link: '/me-encontre',
      hint: 'Local onde você pode encontrar as pessoas do TRT e localidades',
    }),
    //new MenuItem({ nome: 'SISTEMAS-> Siate', link: '/siate', hint: '' }),
    new MenuItem({
      nome: 'OUTROS-> Endereços de Email',
      link: '/endereco-email',
      hint: 'Lista de endereços de email das pessoas, localidades e listas',
    }),
    new MenuItem({
      nome: 'OUTROS-> Notificações',
      link: '/notificacao',
      hint: 'Lista de notificações',
    }),
    new MenuItem({
      nome: 'OUTROS-> Estatística de acesso',
      link: '/recurso-estatistica',
      hint: 'Estatísticas de acesso aos recursos do MeuPortal',
    }),
    new MenuItem({ nome: 'OUTROS-> Feriados', link: '/feriado', hint: '' }),
  ];

  constructor(private _envS: EnvService) {}

  emitirMostrarMenu(pValor: boolean) {
    //console.log('emitirMostrarMenu()', pValor, pRecurso);
    this._envS.mostrarMenu = pValor;
    this.mostrarMenuEmitter.emit(this._envS.mostrarMenu);
  }

  getMostrarMenu(): boolean {
    return this._envS.mostrarMenu;
  }
}
